document.addEventListener('DOMContentLoaded', function() {
  (function() {
    const drawer = document.querySelector('[data-market-drawer-container]');
    const mask = drawer?.querySelector('[data-market-drawer-mask]');
    const content = drawer?.querySelector('[data-market-drawer-content]');
    const closeButton = drawer?.querySelector('[data-market-drawer-close]');
    const openTrigger = document.querySelector('[data-market-drawer]');
    const accordionItems = drawer?.querySelectorAll('[data-market-drawer-accordion-item]');
    const countryLinks = drawer?.querySelectorAll('[data-market-drawer-accordion-link]');
    
    if (accordionItems) {
      accordionItems.forEach(item => {
        const summary = item.querySelector('[data-accordion-summary]');
        const content = item.querySelector('[data-accordion-content]');
        if (!summary || !content) return;
    
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = item.hasAttribute('open');
    
          const extra = 16;
    
          if (isOpen) {
            const startHeight = content.scrollHeight + extra;
            content.style.height = startHeight + "px";
    
            requestAnimationFrame(() => {
              content.style.height = "0px";
              content.style.opacity = "0";
              content.style.transform = "translateY(-6px)";
            });
    
            setTimeout(() => {
              item.removeAttribute("open");
              content.style.height = "";
              content.style.opacity = "";
              content.style.transform = "";
            }, 300);
    
          } else {
            item.setAttribute("open", "");
            content.style.height = "0px";
            content.style.opacity = "0";
            content.style.transform = "translateY(-6px)";
    
            requestAnimationFrame(() => {
              const targetHeight = content.scrollHeight + extra; 
              content.style.height = targetHeight + "px";
              content.style.opacity = "1";
              content.style.transform = "translateY(0)";
            });
          }
        });
      });
    }
    
    const countryCodeInput = drawer?.querySelector('[data-market-drawer-country-code]');
    const localizationFormWrapper = drawer?.querySelector('[data-market-drawer-localization-form]');
    const localizationForm = localizationFormWrapper?.querySelector('form');

    if (!drawer || !mask || !content) return;

    function openDrawer() {
      mask.classList.add('market-drawer__mask--active');
      content.classList.add('market-drawer__content--active');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      mask.classList.remove('market-drawer__mask--active');
      content.classList.remove('market-drawer__content--active');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-market-drawer]');
      if (trigger) {
        e.preventDefault();
        openDrawer();
      }
    })

    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    mask.addEventListener('click', function(e) {
      if (e.target === mask) {
        closeDrawer();
      }
    });

    if (countryLinks) {
      countryLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const countryCode = this.getAttribute('data-country-code');  
          if (countryCodeInput && countryCode) {
            countryCodeInput.value = countryCode;
            if (localizationForm) {
              localizationForm.submit();
            }
          }
        });
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && content.classList.contains('market-drawer__content--active')) {
        closeDrawer();
      }
    });
  })();
});